// redux/menuSlice.js
import { createSlice } from "@reduxjs/toolkit";
//import { sampleMenu } from "../../Entities/RestaurantMenu";

const initialState = {
 // restaurantInfo : sampleMenu.data.restaurant_info,
 // categories : sampleMenu.data.categories,
  menu_items : [],
  status: "idle",   
  error: null,
};

const menuSlice = createSlice({
  name: "menu",
  initialState,
  reducers: {
    setMenu: (state, action) => {
      const { menu_items } = action.payload;
    //  state.restaurantInfo = restaurantInfo;
    //  state.categories = categories;
      state.menu_items = menu_items;
      state.status = "succeeded";
      state.error = null;
    },
     setError(state, action) {
    state.error = action.payload;
    state.status = "failed";
  },
    clearMenu: (state) => {
    //  state.restaurantInfo = null;
    //  state.categories = [];
      state.menu_items = [];
      state.status = "idle";
      state.error = null;
    },
    updateItemPrice: (state, action) => {
      const { menuId, price } = action.payload;
      if (!state.menu_items) return;
      for (const cat of state.menu_items) {
        const item = cat.items.find((i) => i.menu_id === menuId);
        if (item) {
          item.menu_item_price = price;
          break;
        }
      }
    },
  },
});

export const { setMenu,setError,clearMenu,updateItemPrice } = menuSlice.actions;
export default menuSlice.reducer;
